import { IVincularAtributo } from "../../../Interfaces/Geral/AtributosEtapa/AtributosEtapaInterface";
import {
    AtributosEtapaService,
    AtualizarAtributoService,
    DesvincularAtributoEtapaTipoCasoService,
    ListarAtributosDesvinculadosPorEtapaTipoCasoService,
    ListarAtributosPorEtapaTipoCasoObrigatorioService,
    ListarAtributosPorEtapaTipoCasoRepasseService,
    ListarAtributosVinculadosPorEtapaTipoCasoService,
    ListarEtapaCategoriaAtendimentoTipoCasoService,
    VincularAtributoEtapaTipoCasoService,
} from "../../../Services/Geral/AtributosEtapa/AtributosEtapaServices";
import { Controller } from "../../Controller";

export async function AtributosEtapaController(idTipoCaso: number) {
    return Controller(AtributosEtapaService(idTipoCaso));
}

export async function ListarEtapaCategoriaAtendimentoTipoCasoController(
    idTipoCaso: number
) {
    return Controller(
        ListarEtapaCategoriaAtendimentoTipoCasoService(idTipoCaso)
    );
}

export async function ListarAtributosVinculadosPorEtapaTipoCasoController(
    idTipoCaso: number,
    idEtapa: number
) {
    return Controller(
        ListarAtributosVinculadosPorEtapaTipoCasoService(idTipoCaso, idEtapa)
    );
}

export async function VincularAtributoEtapaTipoCasoController(
    requestBody: Array<IVincularAtributo>
) {
    return Controller(VincularAtributoEtapaTipoCasoService(requestBody));
}

export async function ListarAtributosDesvinculadosPorEtapaTipoCasoController(
    idTipoCaso: number,
    idEtapa: number
) {
    return Controller(
        ListarAtributosDesvinculadosPorEtapaTipoCasoService(idTipoCaso, idEtapa)
    );
}

export async function DesvincularAtributoEtapaTipoCasoController(
    idAtributoEtapaTipoCaso: number[]
) {
    return Controller(
        DesvincularAtributoEtapaTipoCasoService(idAtributoEtapaTipoCaso)
    );
}

export async function AtualizarAtributoController(
    requestBody: IVincularAtributo
) {
    return Controller(AtualizarAtributoService(requestBody));
}

export async function ListarAtributosPorEtapaTipoCasoObrigatorioController(
    idTipocaso: number,
    idEtapa: number
) {
    return Controller(
        ListarAtributosPorEtapaTipoCasoObrigatorioService(idTipocaso, idEtapa)
    );
}

export async function ListarAtributosVinculadosPorEtapaTipoCasoRepasseController(
    idTipoCaso: number,
    idEtapa: number
) {
    return Controller(
        ListarAtributosPorEtapaTipoCasoRepasseService(idTipoCaso, idEtapa)
    );
}
